
import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import AnimateInView from '@/components/ui/animate-in-view';

const ContactInfo = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl mb-6 text-forti-fi">Contact Information</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <AnimateInView animation="fade-in" delay={100} className="premium-card p-6 hover:shadow-luxury-gold transition-all duration-300">
          <div className="flex items-start space-x-3">
            <MapPin className="text-forti-fi h-5 w-5" />
            <p className="text-forti-fi-charcoal">
              Ontario, Canada
            </p>
          </div>
        </AnimateInView>
        
        <AnimateInView animation="fade-in" delay={200} className="premium-card p-6 hover:shadow-luxury-gold transition-all duration-300">
          <div className="flex items-start space-x-3">
            <Phone className="text-forti-fi h-5 w-5" />
            <p className="text-forti-fi-charcoal">
              <a href="tel:+15551234567" className="hover:text-forti-fi transition-colors">(XXX) XXX-XXXX</a>
            </p>
          </div>
        </AnimateInView>
        
        <AnimateInView animation="fade-in" delay={300} className="premium-card p-6 hover:shadow-luxury-gold transition-all duration-300">
          <div className="flex items-start space-x-3">
            <Mail className="text-forti-fi h-5 w-5" />
            <p className="text-forti-fi-charcoal">
              <a href="mailto:info@forti-fi.ca" className="hover:text-forti-fi transition-colors">info@forti-fi.ca</a>
            </p>
          </div>
        </AnimateInView>
        
        <AnimateInView animation="fade-in" delay={400} className="premium-card p-6 hover:shadow-luxury-gold transition-all duration-300">
          <div className="flex items-start space-x-3">
            <Clock className="text-forti-fi h-5 w-5" />
            <p className="text-forti-fi-charcoal">
              Monday - Friday: 9:00 AM - 5:00 PM
            </p>
          </div>
        </AnimateInView>
      </div>
    </div>
  );
};

export default ContactInfo;
